import { Injectable } from "@angular/core";
import { IntefrationLogAPIConstant } from "../constant/integration-log.constant";
import { RestService } from "../../../core/service/rest.service";

@Injectable({
    providedIn: 'root'
})
export class IntegrationLogService {
    constructor(private rest: RestService) { }
    GetIntegrationLogs(payload: any) { return this.rest.post(IntefrationLogAPIConstant.GET_INTEGRATION_LOG, payload) }
    GetIntegrationLogDetails(payload: any) { return this.rest.get(IntefrationLogAPIConstant.GET_INTEGRATION_LOG_DETAILS, payload) }
    GetProductVariantById(payload: any) { return this.rest.get(IntefrationLogAPIConstant.GET_PRODUCT_VARIANT_BY_ID, payload) }
    GetRawMaterialById(payload: any) { return this.rest.get(IntefrationLogAPIConstant.GET_RAW_MATERIAL_BY_ID, payload) }
    GetGenericGroupById(payload: any) { return this.rest.get(IntefrationLogAPIConstant.GET_GENERIC_GROUP_BY_ID, payload) }
    ReProcess(payload: any) { return this.rest.post(IntefrationLogAPIConstant.RE_PROCESS, payload) }
    ProcessContent(payload: any) { return this.rest.post(IntefrationLogAPIConstant.PROCESS_CONTENT, payload) }
    MaterialMaster(stringData:string) { return this.rest.post_string(IntefrationLogAPIConstant.MATERIAL_MASTER, stringData) }
    GetProcessContentDetailsById(payload: any) { return this.rest.get(IntefrationLogAPIConstant.GET_PROCESS_CONTENT_DETAILS_BY_ID, payload) }

}